import React from 'react';
import { BlogContainer, BlogHeadingText } from '../Blog/BlogStyles';

const Suggestions = () => {
    return (
        <BlogContainer>
            <BlogHeadingText>Coming Soon...</BlogHeadingText>
        </BlogContainer>
    );
};

export default Suggestions;